<template>
  <component
    :class="[
      'ss__mobile__menu__item'
    ]"
    :is="item.url && !noJump ? 'a' : 'SsButton2'"
    :href="item.url"
    :target="item.blank ? '_blank' : '_self'"
    :style="item.style"
    type="text">
    <i v-if="item.icon" :class="['ss__mobile__menu__item__icon', item.icon]"/>
    <img
      v-if="item.img"
      class="ss__mobile__menu__item__img"
      :src="$formatImageSrc(item.img, { w: 280, h: 280 })"
      :alt="item.name"
    />
    <span class="ss__mobile__menu__item__name">{{ item.name }}</span>
    <span v-if="item.summary" class="ss__mobile__menu__item__summary">{{ item.summary }}</span>
    <i v-if="item.url && item.external" class="ssCommunityIcon__arrowTopRight"/>
    <i v-if="item.children && item.children.length" class="ssCommunityIcon__arrowExpand"/>
  </component>
</template>

<script>
import SsButton2 from '../../../SsButton2'
export default {
  name: 'SsMobileMenuItem',

  components: {
    SsButton2
  },

  props: {
    item: {
      type: Object,
      required: true
    },
    noJump: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="stylus" scoped>
.ss__mobile__menu__item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  width: var(--width-SsMobileMenuItem, 100%);
  height: var(--height-SsMobileMenuItem, 56px);
  column-gap: 8px;
  &::before {
    background: transparent;
  }
  .ss__mobile__menu__item__icon {
    font-size: var(--size-SsMobileMenuItemIcon, 32px);
    color: var(--color-SsMobileMenuItemIcon, var(--B8-t));
  }
  .ss__mobile__menu__item__img {
    width: var(--size-SsMobileMenuItemImg, 140px);
    height: var(--size-SsMobileMenuItemImg, 140px);
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }
  .ss__mobile__menu__item__name {
    font-size: var(--text-SsMobileMenuItemName, 17px);
    color: var(--color-SsMobileMenuItemName, var(--B8-t));
    font-weight: var(--weight-SsMobileMenuItemName, 500);
    font-family: var(--font-SsMobileMenuItemName, inherit);
  }
  .ss__mobile__menu__item__summary {
    font-size: var(--text-SsMobileMenuItemSummary, 13px);
    color: var(--color-SsMobileMenuItemSummary, var(--B6-t));
    font-weight: var(--weight-SsMobileMenuItemSummary, 400);
  }
  .ssCommunityIcon__arrowTopRight {
    margin-left: auto;
    font-size: var(--size-SsMobileMenuItemIconArrowTopRight, 16px);
    color: var(--color-SsMobileMenuItemIconArrowTopRight, var(--B5-t));
  }
  .ssCommunityIcon__arrowExpand {
    margin-left: auto;
    font-size: var(--size-SsMobileMenuItemIconArrowExpand, 16px);
    color: var(--color-SsMobileMenuItemIconArrowExpand, var(--B5-t));
  }
}
</style>
